import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1 className='text-center font-4xl text-bold mt-12'>Comming Soon.........</h1>
        </div>
    );
};

export default Contact;